import {
  GetControlAttributesCommandInput,
  GetControlDataCommandInput,
  GetControlsCommandInput,
  GetHistoricalExecutionDataCommandInput,
  GetSnapshotCommandInput,
} from '@amzn/controllershiphub-typescript-client';
import { useQuery } from '@tanstack/react-query';
import controllershipHub from '../clients/chub-client';
import { queryKeys } from '../utils/queryKeys';
import { handleApiRequest } from '../utils/apiRequest';
import { CACHE_TIME, STALE_TIME } from 'src/constants';

export function useControls(input: GetControlsCommandInput = {}) {
  return useQuery({
    queryKey: queryKeys.controls.list(),
    queryFn: () => handleApiRequest(() => controllershipHub.getControls(input)),
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
  });
}

export function useControlData(input: GetControlDataCommandInput) {
  return useQuery({
    queryKey: queryKeys.controls.data(input.controlId),
    queryFn: () => handleApiRequest(() => controllershipHub.getControlData(input)),
    enabled: !!input.controlId,
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
  });
}

export function useControlAttributes(input: GetControlAttributesCommandInput) {
  return useQuery({
    queryKey: queryKeys.controls.attributes(input.controlId),
    queryFn: () => handleApiRequest(() => controllershipHub.getControlAttributes(input)),
    enabled: !!input.controlId,
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
  });
}

export function useHistoricalExecutionData(input: GetHistoricalExecutionDataCommandInput) {
  return useQuery({
    queryKey: queryKeys.controls.historical(input.controlId),
    queryFn: () => handleApiRequest(() => controllershipHub.getHistoricalExecutionData(input)),
    enabled: !!input.controlId,
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
  });
}

export function useGetGRCReviewCycleSnapshotUrl(
  input: GetSnapshotCommandInput,
  enabled: boolean = false
) {
  const yearParam = input.parameters?.find((p) => p.key === 'year')?.value;
  const monthParam = input.parameters?.find((p) => p.key === 'month')?.value;
  const phaseParam = input.parameters?.find((p) => p.key === 'phasename')?.value;

  return useQuery({
    queryKey: ['snapshot', input.controlId, yearParam, monthParam, phaseParam],
    queryFn: () => handleApiRequest(() => controllershipHub.getGRCReviewCycleSnapshotUrl(input)),
    enabled: enabled && !!(yearParam && monthParam && phaseParam),
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
    retry: 2,
    retryDelay: 1000,
  });
}
